import {Dispatch, SetStateAction} from 'react'
import {PopupSize, PopupTemplate, ButtonColorTheme, OptimizedImage} from '..'
import {handleEsc} from '../../lib'
import {selectTheme} from '../../store'
import {TaskType} from '../../shared/db'
import MovesenseInstructionImg from '../../asset/image/movesense_instruction.png'
import GarminStreamInstructionImg from '../../asset/image/garmin_stream_instruction.png'

const deviceTypeData = {
  stopwatch_movesense_stream: {
    testId: 'movesense_instruction_pop',
    image: MovesenseInstructionImg,
    title: 'Next: Add a Movesense Task',
    description: `Your participants will need to activate the data recording through a Movesense Task on the participant app. Please create Movesense Task in the project builder.`,
    btnText: 'Close',
    buttonText: 'Add Scheduled Task',
    optionalSecondaryButtonContent: 'Add Event Tracker',
  },
  stopwatch_garmin_stream: {
    testId: 'garmin_stream_instruction_pop',
    image: GarminStreamInstructionImg,
    title: 'Next: Add a Garmin Streaming Task',
    description: `You've selected a high-resolution data type that cannot be collected continuously due to the overwhelming amount of data generated. Your participants will need to activate the data recording through a Garmin Streaming Task on the participant app. Please create a Garmin Streaming Task to guide the participants on what they need to do.`,
    btnText: "I'll add a Garmin Streaming Task later",
    buttonText: "I'll add a Garmin Streaming Task later",
    optionalSecondaryButtonContent: undefined,
  },
}

export const PopupDeviceInstruction = (props: {
  deviceType: TaskType.StopwatchMovesenseStream | TaskType.StopwatchGarminStream
  setDisplayInstructionPop: Dispatch<
    SetStateAction<TaskType.StopwatchMovesenseStream | TaskType.StopwatchGarminStream | ''>
  >
  onAddScheduledTask?: () => void
  onAddEventTracker?: () => void
}) => {
  const {color, fontWeight} = selectTheme()
  const {deviceType, setDisplayInstructionPop, onAddScheduledTask, onAddEventTracker} = props
  const {testId, image, title, description, btnText, buttonText, optionalSecondaryButtonContent} =
    deviceTypeData[deviceType]
  const isMovesense = deviceType === TaskType.StopwatchMovesenseStream

  const closeAction = () => setDisplayInstructionPop('')

  const handleAddScheduledTask = () => {
    closeAction()
    onAddScheduledTask?.()
  }

  const handleAddEventTracker = () => {
    closeAction()
    onAddEventTracker?.()
  }

  handleEsc(closeAction)

  const closeLink = (
    <button
      type='button'
      onClick={closeAction}
      css={{
        color: color.primary,
        fontWeight: fontWeight.bold,
        cursor: 'pointer',
        border: 'none',
        background: 'transparent',
        padding: 0,
      }}>
      {btnText}
    </button>
  )

  const descriptionContent = (
    <div css={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
      <img src={image} alt={`Illustration: ${title}`} />
      <p
        css={{
          color: color.textIcon.secondary,
          fontWeight: fontWeight.bold,
          whiteSpace: 'pre-line',
        }}>
        {description}
      </p>
    </div>
  )

  return (
    <div data-testid={testId}>
      <PopupTemplate
        {...{
          title,
          description: descriptionContent,
          background: true,
          popupSize: PopupSize.Medium,
          handleClosePopup: closeAction,
          hideCancelButton: true,
          optionalBottomLeftContent: isMovesense ? closeLink : undefined,
          mainFunction: isMovesense ? handleAddScheduledTask : closeAction,
          buttonContent: buttonText,
          buttonColorTheme: isMovesense ? ButtonColorTheme.Primary : ButtonColorTheme.Grey,
          optionalSecondaryButtonContent: isMovesense ? optionalSecondaryButtonContent : undefined,
          optionalSecondaryButtonFunction: isMovesense ? handleAddEventTracker : undefined,
          optionalSecondaryButtonColorTheme: ButtonColorTheme.Primary,
        }}
      />
    </div>
  )
}
